export default __webpack_public_path__ + "static/media/loader.dd8ffae1.svg";